module.exports = __webpack_public_path__ + "img/aidt.c5d7d81f.jpg";